import { dataBookmarkSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookmarkSolid = /*#__PURE__*/createIcon(dataBookmarkSolid)
export default IconBookmarkSolid
